<script setup>
import { ref, watch } from 'vue';
import Draggable from 'vuedraggable';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  stages: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete', 'reorder']);

const localStages = ref([...props.stages]);

watch(
  () => props.stages,
  value => {
    localStages.value = [...value];
  }
);

const onDragEnd = () => {
  const positionsHash = localStages.value.reduce((hash, stage, index) => {
    hash[stage.id] = index + 1;
    return hash;
  }, {});
  emit('reorder', positionsHash);
};
</script>

<template>
  <Draggable
    v-model="localStages"
    item-key="id"
    tag="ul"
    class="flex flex-col gap-2"
    handle=".kanban-stage-drag-handle"
    @end="onDragEnd"
  >
    <template #item="{ element }">
      <li
        class="flex items-center gap-2 p-2 border rounded-lg list-none border-n-weak bg-n-solid-2"
      >
        <i
          class="cursor-grab kanban-stage-drag-handle i-lucide-grip-vertical text-n-slate-10"
        />
        <span
          class="w-2.5 h-2.5 rounded-full shrink-0"
          :style="{ backgroundColor: element.color }"
        />
        <span class="text-sm truncate text-n-slate-12 grow">
          {{ element.name }}
        </span>
        <Button
          type="button"
          icon="i-lucide-pencil"
          slate
          xs
          variant="ghost"
          @click="emit('edit', element)"
        />
        <Button
          type="button"
          icon="i-lucide-trash"
          slate
          xs
          variant="ghost"
          @click="emit('delete', element)"
        />
      </li>
    </template>
  </Draggable>
</template>
